<script>
  import { onMount } from "svelte";
  import { Burger, Menu } from "@svelteuidev/core";
  import ListaHorarios from "./ListaHorarios.svelte";
  import Conexoes from "../Classes/Conexoes";

  const conexao = new Conexoes();
  let showModal = false;
  let menuOpen = false;
  let menuElement;

  // ------ SEO Constantes ------
  const SITE_URL = "https://www.allinemenezes.com.br";
  const SITE_TITLE =
    "Nutricionista Campina Grande - Alline Menezes | Saúde e Bem-Estar";
  const SITE_DESCRIPTION =
    "Alline Menezes, nutricionista em Campina Grande, pós-graduada em nutrição clínica e pós-graduanda em nutrição esportiva. Agende sua consulta presencial ou online por videoconferência.";
  const SITE_IMAGE_URL = `${SITE_URL}/img/5.webp`;

  const diferenciais = [
    {
      icone: "fas fa-user-check",
      titulo: "Atendimento Verdadeiramente Personalizado",
      descricao:
        "Sua consulta é única. Dedico tempo para entender suas necessidades, rotina, preferências e histórico de saúde. Nada de planos genéricos! Construímos, juntos, um plano alimentar que se encaixa perfeitamente na sua vida."
    },
    {
      icone: "fab fa-whatsapp",
      titulo: "Suporte Contínuo e Próximo",
      descricao:
        "Estarei ao seu lado durante toda a jornada. Você terá acesso direto a mim via WhatsApp para tirar dúvidas, receber orientações e fazer ajustes no seu plano, sempre que precisar. Seu sucesso é o meu compromisso!"
    },
    {
      icone: "fas fa-mobile-alt",
      titulo: "Tecnologia a Seu Favor: Aplicativo WebDiet",
      descricao:
        "Você terá acesso ao WebDiet, um aplicativo completo e intuitivo para acompanhar sua evolução, acessar seu plano alimentar, receitas deliciosas e interagir comigo de forma prática e segura."
    },
    {
      icone: "fas fa-handshake",
      titulo: "Abordagem Gentil e sem Radicalismos",
      descricao:
        "Acredito em uma nutrição que respeita seu corpo e suas preferências. Nada de dietas restritivas ou proibições! Meu foco é em mudanças de hábitos graduais e sustentáveis, que te proporcionam saúde e bem-estar a longo prazo."
    },
    {
      icone: "fas fa-medal",
      titulo: "Pós-graduada em Nutrição Clínica",
      descricao:
        "Minha formação em Nutrição Clínica me permite oferecer um cuidado baseado em evidências científicas, com foco na prevenção e tratamento de condições de saúde, além da promoção do bem-estar.",
      nota: ""
    },
    {
      icone: "fas fa-book-open",
      titulo: "Experiência que Transforma",
      descricao:
        "Minha própria jornada de superação me inspira a guiar você em direção a uma vida mais saudável. Sei, na prática, que é possível mudar e conquistar seus objetivos. Conte comigo para te apoiar nessa transformação!"
    }
  ];

  let faqData = [
    {
      id: 1,
      question: "Qual a diferença entre nutricionista e nutrólogo?",
      answer:
        "O nutricionista é o profissional graduado em Nutrição, habilitado a prescrever planos alimentares individualizados, focados na promoção, manutenção e recuperação da saúde, através da alimentação. Já o nutrólogo é um médico com especialização em Nutrologia, que diagnostica e trata doenças relacionadas à alimentação, podendo prescrever medicamentos, além de dietas.",
      isOpen: false
    },
    {
      id: 2,
      question: "Como funciona o agendamento com a nutricionista?",
      answer:
        'Você pode agendar sua consulta com sua nutricionista em Campina Grande de forma rápida e fácil clicando no botão "Agendar" no menu superior, ou entrando em contato diretamente pelo WhatsApp, clicando no ícone flutuante no canto inferior direito da tela.',
      isOpen: false
    },
    {
      id: 3,
      question: "Quais formas de pagamento você aceita?",
      answer:
        "Aceitamos pagamentos em dinheiro, cartão de débito, cartão de crédito (com opção de parcelamento) e Pix.",
      isOpen: false
    },
    {
      id: 4,
      question:
        "Preciso levar algum exame na primeira consulta com a nutricionista?",
      answer:
        "Se você tiver exames bioquímicos recentes (últimos 3 meses), é interessante trazê-los para sua consulta com a nutricionista. Caso não tenha, não se preocupe, faremos uma avaliação completa durante a consulta e, se necessário, solicitarei os exames complementares.",
      isOpen: false
    },
    {
      id: 5,
      question: "Vocês atendem convênios?",
      answer:
        "No momento, atendemos apenas consultas particulares. No entanto, posso fornecer recibo para reembolso, caso seu plano de saúde ofereça essa opção.",
      isOpen: false
    },
    {
      id: 6,
      question: "Como funcionam as consultas online?",
      answer:
        "Caso o paciente deseje por uma consulta online, elas podem ser realizadas por videochamada, através de plataformas como WhatsApp, Zoom ou Google Meet, de acordo com a sua preferência. O processo é o mesmo da consulta presencial, com avaliação, orientações e acompanhamento personalizados, no entanto o paciente precisar ter realizado recentemente uma avaliação de bioimpedância para uma melhor avaliação.",
      isOpen: false
    },
    {
      id: 7,
      question: "O que é bioimpedância?",
      answer:
        "A bioimpedância é um exame que avalia a composição corporal, medindo a quantidade de massa magra (músculos), gordura, água e outros componentes do corpo. É um método rápido, indolor e não invasivo, que utiliza uma corrente elétrica de baixa intensidade, essencial para o acompanhamento com sua nutricionista.",
      isOpen: false
    },
    {
      id: 8,
      question: "O que são medidas antropométricas?",
      answer:
        "As medidas antropométricas são medidas do corpo, como peso, altura, circunferências (cintura, quadril, braço, etc.) e dobras cutâneas (medida da espessura da gordura sob a pele). Essas medidas ajudam a avaliar o estado nutricional e a acompanhar a evolução do paciente com a nutricionista.",
      isOpen: false
    },
    {
      id: 9,
      question: "Com que frequência devo retornar à nutricionista?",
      answer:
        "Um retorno por mês (incluso no valor da consulta) e nova avaliação a cada dois meses é o recomendado para seu acompanhamento nutricional.",
      isOpen: false
    },
    {
      id: 10,
      question: "Preciso fazer dieta para ter resultados?",
      answer:
        'Não necessariamente. A palavra "dieta" muitas vezes tem uma conotação negativa, associada a restrições. Meu objetivo como sua nutricionista é te ajudar a ter uma alimentação saudável e equilibrada, sem radicalismos, com mudanças graduais e sustentáveis. O foco é na reeducação alimentar, e não em dietas restritivas.',
      isOpen: false
    },
    {
      id: 11,
      question:
        "Como a nutricionista pode me ajudar a emagrecer em Campina Grande?",
      answer:
        "Sua nutricionista em Campina Grande te ajuda a emagrecer de forma saudável e duradoura, através de um plano alimentar individualizado, que considera suas necessidades, preferências e rotina. Além disso, o nutricionista te orienta sobre escolhas alimentares, controle de porções, combate à compulsão alimentar e mudança de hábitos, promovendo um emagrecimento sustentável.",
      isOpen: false
    }
  ];

  function handleClickOutside(event) {
    if (menuOpen && menuElement && !menuElement.contains(event.target)) {
      menuOpen = false;
    }
  }

  onMount(() => {
    if (window.location.hash === "#agendar") {
      AbrirModal();
    }
    RegitraAcesso();
    function changeImage() {
      currentImageIndex = Math.floor(Math.random() * images.length);
    }
    changeImage();

    return () => {};
  });

  function AbrirModal() {
    console.log("clicou em agendar");
    showModal = true;
  }

  let currentImageIndex = 0;
  const images = [
    "./img/1.webp",
    "./img/2.webp",
    "./img/3.webp",
    "./img/4.webp"
  ];

  async function RegitraAcesso() {
    console.log("Registrando acesso à página Home");
  }

  // --- Schema.org JSON-LD para FAQ ---
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map(item => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: item.answer
      }
    }))
  };

  // --- Schema.org JSON-LD para Physician/LocalBusiness ---
  const physicianSchema = {
    "@context": "https://schema.org",
    "@type": "Physician",
    name: "Alline Menezes Nutricionista Campina Grande",
    image: SITE_IMAGE_URL,
    "@id": SITE_URL,
    url: SITE_URL,
    telephone: "+5581996280325",
    priceRange: "$$",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Av. Mal Floriano Peixoto, 1054 - Clínica Dr. Luciano Lobo",
      addressLocality: "Campina Grande",
      addressRegion: "PB",
      postalCode: "58406-133",
      addressCountry: "BR"
    },
    geo: {
      "@type": "GeoCoordinates",
      latitude: -7.2177500927880445,
      longitude: -35.882133127329304
    },
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "18:00"
      }
    ],
    sameAs: ["https://instagram.com/allinemenezes.nutri"],
    description:
      "Alline Menezes, nutricionista em Campina Grande, PB. Pós-graduada em nutrição clínica, emagrecimento saudável, saúde intestinal e reeducação alimentar. Agende sua consulta.",
    makesOffer: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Consulta Nutricional Personalizada em Campina Grande"
        }
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Acompanhamento para Emagrecimento em Campina Grande"
        }
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Nutrição Clínica em Campina Grande"
        }
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Avaliação de Bioimpedância" }
      },
      {
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: "Reeducação Alimentar" }
      }
    ]
  };
</script>

<style>
  /* SEUS ESTILOS EXISTENTES */
  @font-face {
    font-family: "Century Gothic";
    src: url("CenturyGothic.ttf") format("truetype");
    font-weight: normal;
    font-style: normal;
  }

  .contatos-container {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 40px 0;
  }
  .contato-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  .contato-item img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }
  .barra {
    display: block;
    width: 100%;
    height: auto;
    z-index: 5;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .fale-conosco {
    background-color: white;
    padding: 40px 20px;
    text-align: center;
    border-top: 2px solid #d4af37;
  }

  .fale-conosco h2 {
    font-size: 28px;
    margin-bottom: 30px;
    font-family: "Century Gothic", sans-serif;
  }
  .contatos {
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .contatos p {
    font-size: 18px;
    margin: 10px 0;
    font-family: "Century Gothic", sans-serif;
  }

  .contatos a {
    color: #a1b57d;
    text-decoration: none;
    font-weight: bold;
  }

  .contatos a:hover {
    text-decoration: underline;
  }

  .whatsapp-float {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 60px;
    height: 60px;
    background-color: #1bd741;
    border-radius: 50%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: bounce 2s infinite;
  }

  .whatsapp-float img {
    width: 35px;
    height: 35px;
  }

  .whatsapp-float:hover {
    transform: scale(1.1);
    transition: 0.3s ease;
  }

  @keyframes bounce {
    0%,
    20%,
    50%,
    80%,
    100% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-10px);
    }
    60% {
      transform: translateY(-5px);
    }
  }

  .onde_atendemos {
    margin-top: 4px;
    background-color: #a1b57d;
    padding: 40px 20px;
    margin-bottom: 20px;
    color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    text-align: center;
  }
  .onde_atendemos h3 {
    font-size: 24px;
    margin-bottom: 15px;
  }
  .onde_atendemos p {
    font-size: 17px;
    line-height: 1.6;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
  }

  .centralizado {
    text-align: center;
  }

  .container {
    font-family: "Century Gothic", sans-serif;
    position: relative;
  }
  .marca {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 20%;
    max-width: 150px;
    height: auto;
    opacity: 0.08;
    z-index: 0;
  }
  .foto {
    display: block;
    width: 100%;
    max-width: 300px;
    height: auto;
    order: 2;
    margin-left: 0;
    margin-top: 20px;
  }
  @media (min-width: 768px) {
    .foto {
      margin-left: 20px;
      margin-top: 0;
    }
    .main-section {
      flex-wrap: nowrap;
    }
  }
  .motivational-quote p {
    font-size: 18px;
    font-style: italic;
    color: #666;
    margin-top: 20px;
    text-align: center;
    margin: 40px 20px;
  }

  .rodape {
    background-color: #ffffff;
    padding: 20px 0;
    color: white;
    position: relative;
    margin-top: 4px;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgb(255, 255, 254);
    padding: 10px 20px;
    color: black;
    flex-wrap: wrap;
    position: relative;
  }

  .header::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url("./img/maca.png") no-repeat right center;
    background-size: contain;
    opacity: 0.05;
    z-index: 0;
  }

  .logo {
    display: flex;
    align-items: center;
    text-align: center;
    margin: auto;
    position: relative;
    z-index: 1;
  }

  .logo-icone {
    width: 250px;
    max-width: 100%;
    margin-right: 10px;
  }

  nav ul {
    list-style: none;
    display: flex;
    gap: 15px;
    margin: 0;
    padding: 0;
    flex-wrap: wrap;
    justify-content: center;
  }

  nav a {
    text-decoration: none;
    color: rgb(0, 0, 0);
    font-size: 15px;
    padding: 5px 8px;
  }

  nav a:hover {
    text-decoration: underline;
    color: #a1b57d;
  }

  .fundo-nav {
    background-color: #ffffff;
    padding: 10px 0;
    color: rgb(0, 0, 0);
    position: relative;
    z-index: 1;
  }

  .main-section {
    align-items: center;
    background-color: #ffffff;
    padding: 30px 20px;
    color: rgb(99, 99, 99);
    position: relative;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-wrap: wrap;
  }
  .main-section h1 {
    font-size: 26px;
    color: #333;
    margin-bottom: 15px;
    line-height: 1.3;
  }
  @media (min-width: 768px) {
    .main-section h1 {
      font-size: 32px;
    }
  }

  .about {
    max-width: 600px;
    margin-left: 0;
    position: relative;
    z-index: 1;
  }
  @media (min-width: 768px) {
    .about {
      margin-left: 40px;
    }
  }

  .about p {
    font-size: 17px;
    line-height: 1.6;
    margin-bottom: 25px;
  }

  .about button {
    background-color: #a1b57d;
    color: #ffffff;
    border: none;
    padding: 12px 22px;
    font-size: 17px;
    cursor: pointer;
    border-radius: 5px;
    transition: background-color 0.3s ease;
  }

  .about button:hover {
    background-color: #8aa864;
  }

  .ajuda {
    background-color: #f9f9f9;
    padding: 40px 20px;
    text-align: center;
  }

  .ajuda h2 {
    font-size: 28px;
    margin-bottom: 30px;
    font-family: "Century Gothic", sans-serif;
    color: #333;
  }

  .cards-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .card {
    flex: 1 1 calc(33.333% - 20px);
    min-width: 280px;
    max-width: 320px;
    background-color: #fff;
    border-radius: 10px;
    padding: 25px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease,
      background-color 0.3s ease;
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: 992px) {
    .card {
      flex: 1 1 calc(50% - 20px);
    }
  }

  @media (max-width: 600px) {
    .card {
      flex: 1 1 100%;
      max-width: none;
    }
  }

  .card:hover {
    transform: translateY(-7px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
  }
  .card h3 {
    font-size: 19px;
    margin-top: 10px;
    margin-bottom: 15px;
    color: #333;
    font-family: "Century Gothic", sans-serif;
  }

  .card p {
    font-size: 15px;
    line-height: 1.6;
    color: #555;
    font-family: "Century Gothic", sans-serif;
  }
  .card-icon {
    font-size: 2.2rem;
    margin-bottom: 0.5rem;
  }
  .card-alimentacao {
    border-top: 4px solid #8ac926;
  }
  .card-alimentacao:hover {
    background-color: #f0f8e8;
  }
  .card-intestino {
    border-top: 4px solid #ff7f11;
  }
  .card-intestino:hover {
    background-color: #fff0e7;
  }
  .card-emagrecimento {
    border-top: 4px solid #1982c4;
  }
  .card-emagrecimento:hover {
    background-color: #e8f3f9;
  }
  .card-metabolico {
    border-top: 4px solid #6a4c93;
  }
  .card-metabolico:hover {
    background-color: #edeaf2;
  }
  .card-avaliacao {
    border-top: 4px solid #ffca3a;
  }
  .card-avaliacao:hover {
    background-color: #fff8e9;
  }
  .card-massa {
    border-top: 4px solid #8ac926;
  }
  .card-massa:hover {
    background-color: #f0f8e8;
  }

  .btn-agendar-cards {
    background-color: #a1b57d;
    color: #fff;
    border: none;
    padding: 12px 24px;
    font-size: 18px;
    cursor: pointer;
    border-radius: 8px;
    transition: background-color 0.3s ease;
    margin-top: 30px;
    font-family: "Century Gothic", sans-serif;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .btn-agendar-cards:hover {
    background-color: #8aa864;
  }

  .detalhes-atendimento {
    background-color: #f9f9f9;
    padding: 40px 20px;
    text-align: center;
  }

  .detalhes-atendimento h2 {
    font-size: 28px;
    margin-bottom: 30px;
    font-family: "Century Gothic", sans-serif;
    color: #333;
  }

  .detalhes-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .detalhe-item {
    flex: 1 1 calc(33.333% - 20px);
    min-width: 280px;
    max-width: 350px;
    background-color: #fff;
    border-radius: 10px;
    padding: 25px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    text-align: center;
    margin: 10px;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  @media (max-width: 992px) {
    .detalhe-item {
      flex: 1 1 calc(50% - 20px);
    }
  }

  @media (max-width: 600px) {
    .detalhe-item {
      flex: 1 1 100%;
      max-width: none;
    }
  }

  .detalhe-item:hover {
    transform: translateY(-7px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
  }

  .detalhe-icone {
    font-size: 2.2rem;
    margin-bottom: 0.5rem;
    color: #a1b57d;
  }
  .detalhe-item h3 {
    font-size: 19px;
    margin-top: 10px;
    margin-bottom: 15px;
    color: #333;
    font-family: "Century Gothic", sans-serif;
  }

  .detalhe-item p {
    font-size: 15px;
    line-height: 1.6;
    color: #555;
    font-family: "Century Gothic", sans-serif;
  }

  /* ESTILOS DA SEÇÃO DE PLANOS (NOVO) */
  .planos {
    background-color: #fff;
    padding: 50px 20px;
    text-align: center;
  }
  .planos h2 {
    font-size: 30px;
    color: #a1b57d;
    font-family: "Century Gothic", sans-serif;
    margin-bottom: 15px;
  }
  .card-plano {
    background: #fff;
    border: 1px solid #eee;
    padding: 30px 20px;
    border-radius: 12px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .card-plano.destaque {
    border: 2px solid #d4af37;
    background-color: #fffcf5;
    transform: scale(1.02);
  }
  .card-plano h3 {
    color: #a1b57d;
    font-size: 24px;
    margin-bottom: 5px;
  }
  .subtitulo-plano {
    display: block;
    font-size: 14px;
    text-transform: uppercase;
    color: #888;
    margin-bottom: 15px;
    letter-spacing: 1px;
    font-weight: bold;
  }
  .lista-beneficios {
    list-style: none;
    padding: 0;
    margin: 20px 0;
    text-align: left;
    width: 100%;
  }
  .lista-beneficios li {
    margin-bottom: 10px;
    color: #555;
    font-size: 15px;
  }
  .lista-beneficios i {
    color: #a1b57d;
    margin-right: 8px;
  }
  .badge-destaque {
    position: absolute;
    top: -12px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #d4af37;
    color: white;
    padding: 5px 15px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .btn-plano {
    display: inline-block;
    padding: 10px 20px;
    border: 1px solid #a1b57d;
    border-radius: 25px;
    color: #a1b57d;
    text-decoration: none;
    font-weight: bold;
    transition: all 0.3s;
    margin-top: 15px;
  }
  .btn-plano:hover {
    background-color: #a1b57d;
    color: white;
    text-decoration: none;
  }
  .btn-destaque {
    background-color: #a1b57d;
    color: white;
  }
  .btn-destaque:hover {
    background-color: #8aa864;
    border-color: #8aa864;
  }

  .faq {
    background-color: #fff;
    padding: 40px 20px;
    text-align: center;
  }

  .faq h2 {
    font-size: 28px;
    margin-bottom: 30px;
    font-family: "Century Gothic", sans-serif;
    color: #333;
  }

  .faq-container {
    max-width: 800px;
    margin: 0 auto;
  }

  .faq-item {
    margin-bottom: 15px;
    border-bottom: 1px solid #eee;
    text-align: left;
  }
  .faq-item:last-child {
    border-bottom: none;
  }

  .faq-question {
    background-color: transparent;
    border: none;
    padding: 15px 5px;
    width: 100%;
    text-align: left;
    font-size: 17px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: "Century Gothic", sans-serif;
    color: #444;
    font-weight: 600;
  }

  .faq-question:hover {
    color: #a1b57d;
  }

  .faq-answer {
    padding: 0px 5px 15px 5px;
    overflow: hidden;
    text-align: left;
  }

  .faq-answer p {
    font-size: 15px;
    line-height: 1.7;
    color: #555;
    margin-bottom: 0;
    font-family: "Century Gothic", sans-serif;
  }

  .fa-chevron-down {
    transition: transform 0.3s ease;
    color: #a1b57d;
  }
  .faq-question i.rotate {
    transform: rotate(180deg);
  }

  .sobre-mim {
    background-color: #fdfdfd;
    padding: 40px 20px;
  }

  .sobre-mim-container {
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 30px;
  }

  .sobre-mim-foto {
    flex: 1 1 300px;
    max-width: 380px;
    display: flex;
    justify-content: center;
  }

  .sobre-mim-foto img {
    width: 100%;
    max-width: 350px;
    height: auto;
    border-radius: 10px;
    object-fit: cover;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  }

  .sobre-mim-texto {
    flex: 2 1 550px;
    text-align: left;
  }

  .sobre-mim-texto h2 {
    font-size: 28px;
    margin-bottom: 10px;
    font-family: "Century Gothic", sans-serif;
    color: #333;
  }

  .sobre-mim-texto h3 {
    font-size: 22px;
    color: #a1b57d;
    margin-bottom: 5px;
    font-family: "Century Gothic", sans-serif;
    font-weight: bold;
  }

  .crn {
    font-size: 15px;
    font-style: italic;
    color: #777;
    margin-bottom: 15px;
  }

  .minha-historia p {
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 1.7;
    color: #555;
    font-family: "Century Gothic", sans-serif;
  }

  @media (max-width: 768px) {
    .sobre-mim-container {
      flex-direction: column;
      align-items: center;
    }
    .sobre-mim-foto {
      max-width: 80%;
      margin-bottom: 20px;
    }
    .sobre-mim-texto h2,
    .sobre-mim-texto h3 {
      text-align: center;
    }
    .crn {
      text-align: center;
    }
  }

  .nota {
    font-size: 12px;
    color: #777;
    font-style: italic;
  }

  .por-que-escolher {
    background-color: #f9f9f9;
    padding: 40px 20px;
    text-align: center;
  }

  .por-que-escolher h2 {
    font-size: 30px;
    margin-bottom: 15px;
    font-family: "Century Gothic", sans-serif;
    color: #d4af37;
  }

  .intro {
    font-size: 17px;
    line-height: 1.6;
    color: #555;
    max-width: 800px;
    margin: 0 auto 30px;
    font-family: "Century Gothic", sans-serif;
  }

  .diferenciais-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
    max-width: 1200px;
    margin: 0 auto;
  }

  .diferencial-item-destaque {
    border: 1px solid #d4af37;
    background-color: #fff;
  }

  .diferencial-item {
    flex: 1 1 calc(50% - 30px);
    min-width: 280px;
    max-width: 420px;
    background-color: #fff;
    border-radius: 10px;
    padding: 25px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    margin: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .diferencial-item:hover {
    transform: translateY(-7px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
  }

  .diferencial-icone {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    color: #d4af37;
  }

  .diferencial-item h3 {
    font-size: 20px;
    margin-bottom: 15px;
    color: #333;
    font-family: "Century Gothic", sans-serif;
  }

  .diferencial-item p {
    font-size: 15px;
    line-height: 1.6;
    color: #555;
    font-family: "Century Gothic", sans-serif;
    text-align: left;
    flex-grow: 1;
  }
  .diferencial-item .nota {
    font-size: 11px;
    text-align: center;
    margin-top: 10px;
    width: 100%;
  }

  .btn-agendar {
    background-color: #a1b57d;
    color: #fff;
    border: none;
    padding: 12px 24px;
    font-size: 18px;
    cursor: pointer;
    border-radius: 8px;
    transition: background-color 0.3s ease;
    margin-top: 30px;
    font-family: "Century Gothic", sans-serif;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .btn-agendar:hover {
    background-color: #8aa864;
  }

  @media (max-width: 992px) {
    .diferencial-item {
      flex: 1 1 100%;
      max-width: 500px;
    }
  }
  @media (max-width: 768px) {
    .intro {
      font-size: 16px;
    }
  }

  .btn-link-online {
    color: #a1b57d;
    text-decoration: underline;
    font-weight: bold;
    font-size: 15px;
    transition: 0.3s;
  }
  .btn-link-online:hover {
    color: #6a8540;
    text-decoration: none;
  }
</style>

<svelte:head>
  <title>{SITE_TITLE}</title>
  <meta name="description" content={SITE_DESCRIPTION} />
  <meta
    name="keywords"
    content="nutricionista campina grande, nutrição campina grande,
    nutricionista clínica campina grande, emagrecimento campina grande,
    reeducação alimentar campina grande, Alline Menezes nutricionista, consulta
    nutricionista campina grande, bioimpedância campina grande" />
  <link rel="canonical" href={SITE_URL} />
  <meta property="og:type" content="website" />
  <meta property="og:url" content={SITE_URL} />
  <meta property="og:title" content={SITE_TITLE} />
  <meta property="og:description" content={SITE_DESCRIPTION} />
  <meta property="og:image" content={SITE_IMAGE_URL} />
  <meta property="og:locale" content="pt_BR" />
  <meta property="og:site_name" content="Alline Menezes Nutricionista" />
  <meta property="twitter:card" content="summary_large_image" />
  <meta property="twitter:url" content={SITE_URL} />
  <meta property="twitter:title" content={SITE_TITLE} />
  <meta property="twitter:description" content={SITE_DESCRIPTION} />
  <meta property="twitter:image" content={SITE_IMAGE_URL} />
  <link
    rel="stylesheet"
    href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
    integrity="sha512-DTOQO9RWCH3ppGqcWaEA1BIZOC6xxalwEsw9c2QQeAIftl+Vegovlnee1c9QX4TctnWMn13TZye+giMm8e2LwA=="
    crossorigin="anonymous"
    referrerpolicy="no-referrer" />
  
</svelte:head>

<main class="container">
  <header
    class="header d-flex flex-column flex-md-row align-items-center
    justify-content-between">
    <div class="d-flex w-100 justify-content-between align-items-center">
      <div class="logo">
        <img
          class="logo-icone"
          src="./img/logo2.png"
          alt="Logo Alline Menezes Nutricionista Campina Grande" />
      </div>
    </div>
    <nav class="navbar fundo-nav w-100 mt-3 mt-md-0">
      <div class="d-none d-md-flex w-100 justify-content-center">
        <ul class="navbar-nav d-flex flex-row justify-content-center">
          <li class="nav-item mx-3">
            <a class="nav-link" href="#home">{'Home'}</a>
          </li>
          <li class="nav-item mx-3">
            <a class="nav-link" href="#planos">{'Planos'}</a>
          </li>
          <li class="nav-item mx-3">
            <a class="nav-link" href="#" on:click={AbrirModal}>
              {'Agendar Consulta Nutricional'}
            </a>
          </li>
          <li class="nav-item mx-3">
            <a
              class="nav-link"
              href="/online/"
              style="color: #a1b57d; font-weight: bold;">
              Atendimento Online (Brasil)
            </a>
          </li>
          <li class="nav-item mx-3">
            <a class="nav-link" href="#ondeEstamos">
              {'Onde Atendemos em Campina Grande'}
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </header>

  <section
    id="home"
    class="main-section d-flex flex-column flex-md-row align-items-center">
    <img
      src="./img/marca.png"
      alt="Marca d'água Alline Menezes Nutricionista"
      class="marca" />

    <div class="about text-center text-md-left">
      <h1>
        Nutricionista em Campina Grande: Transforme Sua Saúde com Alline Menezes
      </h1>
      <p>
        <strong>
          Transforme sua saúde e conquiste o bem-estar que você merece!
        </strong>
        Alline Menezes, sua nutricionista em Campina Grande, pós-graduada em
        Nutrição Clínica e pós-graduanda em nutrição esportiva , oferece um
        acompanhamento personalizado para você alcançar seus objetivos. Descubra
        como uma alimentação equilibrada pode ser a chave para uma vida mais
        leve, saudável e cheia de energia.
      </p>
      <div class="about text-center text-md-left">
        <button
          class="btn btn-primary"
          style="z-index:10"
          on:click={AbrirModal}>
          Agende sua consulta em Campina Grande
        </button>

        <div style="margin-top: 15px;">
          <p style="font-size: 14px; margin-bottom: 5px;">
            Mora em outra cidade?
          </p>
          <a href="/online/" class="btn-link-online">
            Conheça a Consultoria Online ➜
          </a>
        </div>
      </div>
    </div>
    <img
      src={images[currentImageIndex]}
      alt="Alline Menezes, nutricionista em Campina Grande"
      class="foto foto-animada" />
  </section>

  <section class="ajuda">
    <h2>Como sua Nutricionista em Campina Grande Pode Ajudar</h2>
    <div class="cards-container">
      <div class="card card-alimentacao">
        <i class="fas fa-apple-alt card-icon" />
        <h3>Alimentação Saudável em Campina Grande</h3>
        <p>
          <strong>Tenha mais energia e disposição no seu dia a dia!</strong>
          Aprenda a fazer escolhas alimentares inteligentes, que nutrem seu
          corpo e te ajudam a viver com mais vitalidade, sem abrir mão do prazer
          de comer. Sua nutricionista em Campina Grande te guia nesse processo.
        </p>
      </div>
      <div class="card card-intestino">
        <i class="fas fa-heartbeat card-icon" />
        <h3>Saúde Intestinal com Nutricionista</h3>
        <p>
          Estratégias nutricionais para melhorar o funcionamento do seu
          intestino, abordando questões como constipação e diarreia, visando o
          equilíbrio da microbiota e a saúde digestiva com o apoio de uma
          nutricionista.
        </p>
      </div>
      <div class="card card-emagrecimento">
        <i class="fas fa-weight-scale card-icon" />
        <h3>Suporte ao Emagrecimento em Campina Grande</h3>
        <p>
          Acompanhamento nutricional focado em perda de peso saudável e
          sustentável em Campina Grande, com planos alimentares individualizados
          e estratégias para mudança de comportamento alimentar.
        </p>
      </div>
      <div class="card card-metabolico">
        <i class="fas fa-chart-line card-icon" />
        <h3>Controle Metabólico com Nutricionista</h3>
        <p>
          Orientações nutricionais para auxiliar no controle dos níveis de
          glicemia e lipídios no sangue, prevenindo e gerenciando condições como
          diabetes e dislipidemias, com a ajuda da sua nutricionista.
        </p>
      </div>
      <div class="card card-avaliacao">
        <i class="fas fa-clipboard-list card-icon" />
        <h3>Avaliação Nutricional Completa</h3>
        <p>
          Avaliação detalhada do seu estado nutricional, incluindo medidas
          antropométricas (peso, altura, circunferências) e bioimpedância, para
          um plano alimentar preciso e eficaz.
        </p>
      </div>
      <div class="card card-massa">
        <i class="fas fa-dumbbell card-icon" />
        <h3>Ganho de Massa Muscular com Nutricionista</h3>
        <p>
          Plano alimentar personalizado para otimizar o ganho de massa muscular,
          com orientações sobre a ingestão adequada de proteínas, carboidratos e
          outros nutrientes essenciais, alinhado com seus treinos e objetivos,
          elaborado pela sua nutricionista.
        </p>
      </div>
    </div>
    <button class="btn-agendar-cards" on:click={AbrirModal}>
      Agende sua consulta com a nutricionista agora
    </button>
  </section>
<section
        style="background: #a1b57d; padding: 30px 20px; text-align: center;
        color: white;">
        <h3 style="font-size: 22px; margin-bottom: 10px;">
          Não pode vir até a clínica?
        </h3>
        <p style="font-size: 16px; margin-bottom: 20px;">
          Leve o atendimento de excelência para sua casa. Atendo pacientes do
          Brasil e do mundo via videoconferência.
        </p>
        <a
          href="/online/"
          style="background: white; color: #a1b57d; padding: 10px 25px;
          border-radius: 25px; text-decoration: none; font-weight: bold;">
          Saiba como funciona o Online
        </a>
      </section>
  <section class="sobre-mim" id="Sobre_mim">
    <div class="sobre-mim-container">
      <div class="sobre-mim-foto">
        <img
          src="./img/5.webp"
          alt="Foto de Alline Menezes, nutricionista clínica em Campina Grande" />
      </div>
      
      <div class="sobre-mim-texto">
        <h2>
          Sua Nutricionista em Campina Grande: Minha História e Como Posso
          Ajudar
        </h2>
        <h3>Alline Menezes</h3>
        <p class="crn">Nutricionista CRN-6 47556/P</p>
        <p class="crn">Pós-graduada em Nutrição Clínica em Campina Grande</p>

        <div class="minha-historia">
          <p>
            Minha paixão pela nutrição nasceu da minha própria jornada de
            transformação. Sou formada em Direito, mas a vida me reservava um
            caminho diferente. Após a gravidez, enfrentei sérios desafios de
            saúde, incluindo uma trombose que me colocou à beira da morte.
            Ganhei peso, minha autoestima estava abalada e a constipação se
            tornou um problema constante.
          </p>
          <p>
            Com a chegada da pandemia, decidi que era hora de mudar. Comecei a
            me exercitar, a me alimentar de forma mais consciente e descobri um
            novo estilo de vida. A academia, a corrida, o pilates e a dança se
            tornaram meus aliados, e a nutrição, minha paixão.
          </p>
          <p>
            Essa redescoberta me motivou a ajudar outras pessoas a trilharem um
            caminho semelhante. Abandonei a carreira jurídica e mergulhei de
            cabeça no mundo da nutrição. Concluí minha graduação e, logo em
            seguida, uma pós-graduação em Nutrição Clínica, área que me permite
            aplicar todo o conhecimento adquirido para promover saúde e
            bem-estar de forma individualizada para meus pacientes em Campina
            Grande. Atualmente, também sou
            <strong>pós-graduanda em Nutrição Esportiva</strong>
            , ampliando minha atuação para quem busca melhorar a performance,
            ganhar massa muscular ou perder gordura de forma saudável.
          </p>
          <p>
            Hoje, meu objetivo como nutricionista em Campina Grande é mostrar
            que é possível, sim, ter uma vida mais saudável, com mais energia e
            autoestima, sem radicalismos e sem abrir mão do prazer de comer.
            Acredito em uma nutrição gentil, personalizada e que se adapta à sua
            realidade.
          </p>
          <p>
            Quero te ajudar a construir uma relação positiva com a comida e a
            conquistar a saúde e o bem-estar que você merece.
          </p>
        </div>
      </div>
    </div>

  </section>

  <section class="por-que-escolher">
    <h2>
      Por Que Escolher Alline Menezes, sua Nutricionista em Campina Grande?
    </h2>
    <p class="intro">
      Descubra os diferenciais que tornam meu atendimento como nutricionista em
      Campina Grande único e te ajudam a alcançar seus objetivos de saúde e
      bem-estar de forma eficaz e duradoura.
    </p>

    <div class="diferenciais-container">
      {#each diferenciais as diferencial (diferencial.titulo)}
        <div class="diferencial-item diferencial-item-destaque">
          <i class={diferencial.icone + ' diferencial-icone'} />
          <h3>{diferencial.titulo}</h3>
          <p>{diferencial.descricao}</p>
          {#if diferencial.nota}
            <p class="nota">{diferencial.nota}</p>
          {/if}
        </div>
      {/each}
    </div>

    <button class="btn-agendar" on:click={() => (showModal = true)}>
      Agende sua consulta com sua nutricionista e sinta a diferença!
    </button>
  </section>

  <img src="./img/barra.png" alt="Barra divisória decorativa" class="barra" />
  <section class="rodape">
    <div class="motivational-quote">
      <p>
        "Que seu remédio seja seu alimento, e que seu alimento seja seu
        remédio." — Hipócrates
      </p>
    </div>
  </section>
  <section class="detalhes-atendimento">
    <h2>
      Sua Jornada para uma Vida Mais Saudável com sua Nutricionista em Campina
      Grande: Como Funciona
    </h2>
    <div class="detalhes-container">
      <div class="detalhe-item">
        <i class="fas fa-user-check detalhe-icone" />
        <h3>Atendimento Nutricional Personalizado</h3>
        <p>
          Cada consulta com sua nutricionista é individualizada, focada nas suas
          necessidades, objetivos e histórico de saúde. Construímos juntos um
          plano alimentar que se encaixa na sua rotina.
        </p>
      </div>
      <div class="detalhe-item">
        <i class="fas fa-parking detalhe-icone" />
        <h3>Estacionamento Conveniente</h3>
        <p>
          A clínica onde sua nutricionista atende em Campina Grande oferece
          estacionamento para sua maior comodidade, tornando sua visita mais
          tranquila.
        </p>
      </div>
      <div class="detalhe-item">
        <i class="fab fa-whatsapp detalhe-icone" />
        <h3>Acompanhamento Contínuo com sua Nutricionista</h3>
        <p>
          Estarei disponível via WhatsApp para tirar suas dúvidas, oferecer
          suporte e fazer ajustes no seu plano alimentar sempre que necessário.
        </p>
      </div>
      <div class="detalhe-item">
        <i class="fas fa-mobile-alt detalhe-icone" />
        <h3>Aplicativo WebDiet</h3>
        <p>
          Você terá acesso ao aplicativo WebDiet, uma ferramenta completa para
          acompanhar sua evolução, acessar seu plano alimentar, receitas e
          interagir com sua nutricionista de forma prática.
        </p>
      </div>
      <div class="detalhe-item">
        <i class="fas fa-balance-scale detalhe-icone" />
        <h3>Bioimpedância</h3>
        <p>
          Utilizo a balança de bioimpedância da Omron para avaliação da sua
          composição corporal. Medimos seu percentual de gordura, massa
          muscular, gordura visceral, metabolismo basal e idade metabólica.
          Esses dados são essenciais para um plano alimentar personalizado e
          eficaz.
        </p>
      </div>
      <div class="detalhe-item">
        <i class="fas fa-ruler-combined detalhe-icone" />
        <h3>Medidas Antropométricas Detalhadas</h3>
        <p>
          Realizo medidas antropométricas, incluindo dobras cutâneas,
          circunferências e medição de diâmetros ósseos com paquímetro. Essas
          medidas, combinadas com a bioimpedância, fornecem um panorama
          detalhado do seu estado nutricional.
        </p>
      </div>
    </div>
    <button class="btn-agendar-cards" on:click={AbrirModal}>
      Agende sua consulta com a nutricionista
    </button>
  </section>

  <section class="planos" id="planos">
    <h2>Escolha o Plano Ideal para Sua Transformação</h2>
    <p class="intro">
      Do pontual ao acompanhamento contínuo. Escolha como quer cuidar da sua
      saúde.
    </p>

    <div class="cards-container">
      <div class="card card-plano">
        <h3>Start</h3>
        <span class="subtitulo-plano">Consulta Avulsa</span>
        <p>Ideal para avaliações pontuais e direcionamento inicial.</p>
        <ul class="lista-beneficios">
          <li>
            <i class="fas fa-check" />
            Avaliação Física Completa
          </li>
          <li>
            <i class="fas fa-check" />
            Plano Alimentar Personalizado
          </li>
          <li>
            <i class="fas fa-check" />
            Acesso ao App
          </li>
          <li>
            <i class="fas fa-check" />
            Suporte de 15 dias
          </li>
        </ul>
        <a
          href="https://wa.me/5581996280325?text=Olá! Gostaria de saber o valor
          da Consulta Avulsa (Start)."
          target="_blank"
          class="btn-plano">
          Consultar Valor
        </a>
      </div>

      <div class="card card-plano">
        <h3>Mudança de Hábito</h3>
        <span class="subtitulo-plano">Trimestral</span>
        <p>Para quem busca resultados consolidados em 90 dias.</p>
        <ul class="lista-beneficios">
          <li>
            <i class="fas fa-check" />
            Tudo do plano Start
          </li>
          <li>
            <i class="fas fa-check" />
            Acompanhamento por 3 meses
          </li>
          <li>
            <i class="fas fa-check" />
            Ajustes mensais na dieta
          </li>
        </ul>
        <a
          href="https://wa.me/5581996280325?text=Olá! Gostaria de saber o valor
          do Plano Trimestral."
          target="_blank"
          class="btn-plano">
          Consultar Valor
        </a>
      </div>

      <div class="card card-plano destaque">
        <div class="badge-destaque">Mais Recomendado</div>
        <h3>Estilo de Vida</h3>
        <span class="subtitulo-plano">Semestral</span>
        <p>Transformação completa e reeducação alimentar definitiva.</p>
        <ul class="lista-beneficios">
          <li>
            <i class="fas fa-check" />
            Tudo do plano Trimestral
          </li>
          <li>
            <i class="fas fa-check" />
            Acompanhamento por 6 meses
          </li>
          <li>
            <i class="fas fa-check" />
            Melhor custo-benefício
          </li>
        </ul>
        <a
          href="https://wa.me/5581996280325?text=Olá! Gostaria de saber o valor
          do Plano Semestral (Estilo de Vida)."
          target="_blank"
          class="btn-plano btn-destaque">
          Consultar Condição Especial
        </a>
      </div>
    </div>
  </section>

  <img src="./img/barra.png" alt="Barra divisória decorativa" class="barra" />

  <section class="faq">
    <h2>Perguntas Frequentes sobre Nutricionista em Campina Grande</h2>
    <div class="faq-container">
      {#each faqData as item (item.id)}
        <div class="faq-item">
          <button
            class="faq-question"
            on:click={() => (item.isOpen = !item.isOpen)}>
            {item.question}
            <i class="fas fa-chevron-down" class:rotate={item.isOpen} />
          </button>
          {#if item.isOpen}
            <div class="faq-answer">
              <p>
                {@html item.answer
                  .replace(/nutricionista/g, '<strong>nutricionista</strong>')
                  .replace(
                    /Campina Grande/g,
                    '<strong>Campina Grande</strong>'
                  )}
              </p>
            </div>
          {/if}
        </div>
      {/each}
    </div>
  </section>

  <section id="ondeEstamos" class="onde_atendemos text-center">
    <div class="centralizado">
      <h3 class="centralizado">
        Onde sua Nutricionista Atende em Campina Grande
      </h3>
      <p>
        Sua nutricionista Alline Menezes atende na Clínica Dr. Luciano Lobo, Av.
        Mal Floriano Peixoto, 1054 - Centro, Campina Grande - PB, 58406-133.
        Agende sua consulta!
      </p>
    </div>
    <br />
    <iframe
      title="Localização da nutricionista Alline Menezes em Campina Grande"
      class="w-100"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3958.2023048509304!2d-35.882133127329304!3d-7.2177500927880445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7ac1e53ab40fab7%3A0x3edd9c5118a793d5!2sCl%C3%ADnica%20de%20Otorrinolaringologia%20Dr%20Luciano%20Lobo!5e0!3m2!1spt-BR!2sbr!4v1738014323428!5m2!1spt-BR!2sbr"
      width="600"
      height="450"
      style="border:0;"
      allowfullscreen=""
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade" />
  </section>

  <section class="fale-conosco text-center">
    <h2>
      Pronto(a) para Começar sua Jornada com sua Nutricionista em Campina
      Grande? Fale Comigo!
    </h2>
    <div class="contatos-container">
      <img
        src="./img/marca.png"
        alt="Marca Alline Menezes Nutricionista"
        class="marca" />
      <div class="contatos">
        <div class="contato-item">
          <img src="img/email.png" alt="Email para contato com nutricionista" />
          <strong>Email:</strong>
          <a href="mailto:nutri@allinemenezes.com.br">
            nutri@allinemenezes.com.br
          </a>
        </div>

        <div class="contato-item">
          <img
            src="img/zap.png"
            alt="WhatsApp para agendar consulta com nutricionista em Campina
            Grande" />
          <strong>WhatsApp (Nutricionista Campina Grande):</strong>
          <a href="https://wa.me//5581996280325" target="_blank">
            81 9 9628-0325
          </a>
        </div>

        <div class="contato-item">
          <img
            src="img/instagram.png"
            alt="Instagram da nutricionista Alline Menezes" />
          <strong>Instagram:</strong>
          <a href="https://instagram.com/allinemenezes.nutri" target="_blank">
            @allinemenezes.nutri
          </a>
        </div>
      </div>
    </div>
    <div class="whatsapp-float">
      <a
        href="https://wa.me/5581996280325?text=Olá! Gostaria de agendar uma
        consulta com a nutricionista em Campina Grande."
        target="_blank">
        <img
          src="https://cdn-icons-png.flaticon.com/512/124/124034.png"
          alt="WhatsApp Icon para nutricionista" />
      </a>
    </div>
    <img
      src="./img/barra.png"
      alt="Barra divisória decorativa final"
      class="barra" />
  </section>
  <div class="nota" style="text-align: center; padding: 10px;" />

</main>

<ListaHorarios {showModal} on:close={() => (showModal = false)} />
